<template>
  <header
    class="site-header"
    :class="{
      'is-scrolled': isScrolled,
      'is-top': !isScrolled,
      'menu-open': mobileMenuOpen
    }"
  >
    <div class="header-container container">
      <!-- Logo -->
      <router-link to="/" class="logo" @click.native="closeMenu">
        <img
          class="logo-image"
          :src="officialLogo"
          alt="Archeaux Studio 元基智能"
        />
      </router-link>

      <!-- 桌面端导航 -->
      <nav class="nav-menu">
        <ul class="nav-list" v-if="navItems.length > 0">
          <template v-for="item in navItems">
            <li v-if="navChildren(item.id).length > 0" :key="'d-' + item.id" class="nav-item nav-dropdown" :class="{ active: isDropdownActive(item) }">
              <span class="nav-link nav-link-dropdown">
                {{ item.title }}
                <svg class="dropdown-arrow" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </span>
              <div class="dropdown-wrapper">
                <ul class="dropdown-menu">
                  <li v-for="child in navChildren(item.id)" :key="'dc-' + child.id" :class="{ active: isActive(child.url) }">
                    <router-link :to="child.url" class="dropdown-link">
                      <span class="dropdown-dot" aria-hidden="true"></span>
                      {{ child.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li v-else :key="'s-' + item.id" class="nav-item" :class="{ active: isActive(item.url) }">
              <router-link :to="item.url" class="nav-link" :exact="item.url === '/'">{{ item.title }}</router-link>
            </li>
          </template>
        </ul>
        <ul class="nav-list" v-else>
          <li class="nav-item" :class="{ active: isActive('/') }">
            <router-link to="/" class="nav-link" exact>首页</router-link>
          </li>
          <li class="nav-item nav-dropdown" :class="{ active: isActive('/products') }">
            <span class="nav-link nav-link-dropdown">产品介绍<svg class="dropdown-arrow" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"></polyline></svg></span>
            <div class="dropdown-wrapper">
              <ul class="dropdown-menu">
                <li :class="{ active: isActive('/products/children') }"><router-link to="/products/children" class="dropdown-link"><span class="dropdown-dot" aria-hidden="true"></span>小元基</router-link></li>
                <li :class="{ active: isActive('/products/youth') }"><router-link to="/products/youth" class="dropdown-link"><span class="dropdown-dot" aria-hidden="true"></span>Élément</router-link></li>
                <li :class="{ active: isActive('/products/elderly') }"><router-link to="/products/elderly" class="dropdown-link"><span class="dropdown-dot" aria-hidden="true"></span>守望者</router-link></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" :class="{ active: isActive('/technology') }"><router-link to="/technology" class="nav-link">技术引擎</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/about') }"><router-link to="/about" class="nav-link">关于我们</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/news') }"><router-link to="/news" class="nav-link">新闻动态</router-link></li>
          <li class="nav-item" :class="{ active: isActive('/cooperation') }"><router-link to="/cooperation" class="nav-link">商务合作</router-link></li>
        </ul>
      </nav>

      <!-- 汉堡按钮 -->
      <button
        type="button"
        class="hamburger"
        :class="{ open: mobileMenuOpen }"
        @click.stop="toggleMenu"
        aria-label="菜单"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- 遮罩层 -->
    <div
      v-show="mobileMenuOpen"
      class="menu-overlay"
      @click="closeMenu"
    ></div>

    <!-- 移动端抽屉菜单 -->
    <nav v-show="mobileMenuOpen" class="mobile-nav">
      <div class="mobile-nav-inner">
        <ul class="mobile-nav-list" v-if="navItems.length > 0">
          <template v-for="item in navItems">
            <li v-if="navChildren(item.id).length > 0" :key="'m-' + item.id" class="mobile-section-label">
              <span class="mobile-sub-title">{{ item.title }}</span>
            </li>
            <template v-if="navChildren(item.id).length > 0">
              <li v-for="child in navChildren(item.id)" :key="'mc-' + child.id" class="sub-item" :class="{ active: isActive(child.url) }">
                <router-link :to="child.url" @click.native="closeMenu">{{ child.title }}</router-link>
              </li>
            </template>
            <li v-else :key="'ms-' + item.id" :class="{ active: isActive(item.url) }">
              <router-link :to="item.url" @click.native="closeMenu" :exact="item.url === '/'">{{ item.title }}</router-link>
            </li>
          </template>
        </ul>
        <ul class="mobile-nav-list" v-else>
          <li :class="{ active: isActive('/') }"><router-link to="/" @click.native="closeMenu" exact>首页</router-link></li>
          <li class="mobile-section-label"><span class="mobile-sub-title">产品介绍</span></li>
          <li class="sub-item" :class="{ active: isActive('/products/children') }"><router-link to="/products/children" @click.native="closeMenu">小元基</router-link></li>
          <li class="sub-item" :class="{ active: isActive('/products/youth') }"><router-link to="/products/youth" @click.native="closeMenu">Élément</router-link></li>
          <li class="sub-item" :class="{ active: isActive('/products/elderly') }"><router-link to="/products/elderly" @click.native="closeMenu">守望者</router-link></li>
          <li :class="{ active: isActive('/technology') }"><router-link to="/technology" @click.native="closeMenu">技术引擎</router-link></li>
          <li :class="{ active: isActive('/about') }"><router-link to="/about" @click.native="closeMenu">关于我们</router-link></li>
          <li :class="{ active: isActive('/news') }"><router-link to="/news" @click.native="closeMenu">新闻动态</router-link></li>
          <li :class="{ active: isActive('/cooperation') }"><router-link to="/cooperation" @click.native="closeMenu">商务合作</router-link></li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import officialLogo from '@/assets/images/logo/archeaux-logo-header.webp'

export default {
  name: 'SiteHeader',
  data() {
    return {
      officialLogo,
      isScrolled: false,
      mobileMenuOpen: false,
      currentPath: ''
    }
  },
  computed: {
    ...mapGetters('button', ['navList']),
    navItems() {
      return (this.navList || []).filter(item => !item.parentId || item.parentId === 0)
    },
    navChildren() {
      const list = this.navList || []
      return function (parentId) {
        return list.filter(item => item.parentId === parentId)
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.currentPath = to.path
        this.closeMenu()
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    document.body.style.overflow = ''
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.pageYOffset > 40
    },
    isActive(path) {
      if (!path) return false
      if (path === '/') return this.currentPath === '/'
      return this.currentPath.startsWith(path)
    },
    isDropdownActive(item) {
      const children = this.navChildren(item.id)
      return children.some(child => this.isActive(child.url))
    },
    toggleMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : ''
    },
    closeMenu() {
      this.mobileMenuOpen = false
      document.body.style.overflow = ''
    }
  }
}
</script>

<style lang="scss" scoped>
// ============================================
// Header — Glass Morphism + Editorial Luxury
// ============================================

$header-transition: 0.4s cubic-bezier(0.16, 1, 0.3, 1);
$header-height-scrolled: 64px;

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: $z-index-header;
  height: $header-height;
  transition: height $header-transition, background-color $header-transition, box-shadow $header-transition, backdrop-filter $header-transition;

  // Top of page — floating, transparent
  &.is-top {
    background-color: rgba(255, 255, 255, 0.72);
    backdrop-filter: saturate(180%) blur(18px);
    -webkit-backdrop-filter: saturate(180%) blur(18px);
    box-shadow: inset 0 -1px 0 rgba(139, 115, 85, 0.08);

    .nav-link {
      color: $color-text;
      text-shadow: none;
    }

    .hamburger span {
      background-color: $color-text;
    }
  }

  // Scrolled — frosted glass
  &.is-scrolled {
    height: $header-height-scrolled;
    background-color: rgba(255, 255, 255, 0.82);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04), 0 4px 24px rgba(139, 115, 85, 0.06);

    .logo-image {
      height: 40px;
    }

    .nav-link {
      color: $color-text;
    }

    .hamburger span {
      background-color: $color-text;
    }
  }

  // Menu open override — always opaque
  &.menu-open {
    background-color: rgba(255, 255, 255, 0.98);
    backdrop-filter: saturate(180%) blur(20px);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    box-shadow: none;

    .hamburger span { background-color: $color-text; }
    .nav-link { color: $color-text; }
  }

  @include mobile-only {
    height: $header-height-mobile;

    &.is-scrolled {
      height: 56px;
    }
  }
}

.header-container {
  @include flex-between;
  height: 100%;
}

// ========== Logo ==========
.logo {
  display: flex;
  align-items: center;
  z-index: $z-index-header + 1;
  text-decoration: none;
  flex-shrink: 0;
}

.logo-image {
  width: auto;
  height: 46px;
  max-width: 230px;
  object-fit: contain;
  transition: height $header-transition, filter $header-transition, opacity $header-transition;
  filter: drop-shadow(0 10px 22px rgba(80, 66, 47, 0.14));

  @include mobile-only {
    height: 38px;
    max-width: 176px;
  }
}

// ========== Desktop Navigation ==========
.nav-menu {
  display: flex;
  align-items: center;
  height: 100%;

  @include tablet-only { display: none; }
  @include mobile-only { display: none; }
}

.nav-list {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 20px;
  font-size: 17px;
  font-weight: $font-weight-semibold;
  color: $color-text;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  border-radius: $radius-full;
  transition: color 0.3s ease, background-color 0.3s ease, box-shadow 0.3s ease;
  letter-spacing: 1px;

  // Active pill background
  .nav-item.active > & {
    color: $color-primary;
    background-color: rgba($color-primary, 0.08);
    box-shadow: inset 0 0 0 1px rgba($color-primary, 0.08);
  }

  &:hover {
    color: $color-primary;
    background-color: rgba(255, 255, 255, 0.56);
    box-shadow: inset 0 0 0 1px rgba($color-primary, 0.08);
  }

  // Router link active states
  &.router-link-exact-active,
  &.router-link-active {
    color: $color-primary;
    background-color: rgba($color-primary, 0.08);
    box-shadow: inset 0 0 0 1px rgba($color-primary, 0.08);
  }
}

// ========== Dropdown ==========
.nav-dropdown {
  .nav-link-dropdown {
    .dropdown-arrow {
      transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      opacity: 0.5;
    }
  }

  &:hover {
    .dropdown-arrow {
      transform: rotate(180deg);
      opacity: 1;
    }

    .dropdown-wrapper {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }

    .dropdown-menu {
      transform: translateY(0);
      opacity: 1;
    }
  }

  &.active > .nav-link-dropdown {
    color: $color-primary;
    background-color: rgba($color-primary, 0.07);
  }
}

.dropdown-wrapper {
  position: absolute;
  top: calc(100% - 2px);
  left: 50%;
  transform: translateX(-50%);
  padding-top: 8px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.dropdown-menu {
  position: relative;
  background-color: rgba(255, 255, 255, 0.96);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border: 1px solid rgba(139, 115, 85, 0.08);
  border-radius: $radius-lg;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.02),
    0 12px 32px rgba(139, 115, 85, 0.1),
    0 0 0 0.5px rgba(139, 115, 85, 0.06);
  min-width: 180px;
  padding: 6px;
  transform: translateY(4px);
  opacity: 0;
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;
  list-style: none;
  margin: 0;

  li {
    padding: 0;
    border-radius: 8px;
    overflow: hidden;

    &.active .dropdown-link {
      color: $color-primary;
      background-color: rgba($color-primary, 0.06);
    }
  }
}

.dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  font-size: 16px;
  font-weight: $font-weight-semibold;
  color: $color-text;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;
  border-radius: 6px;

  &:hover {
    color: $color-primary;
    background-color: rgba($color-primary, 0.05);
  }
}

.dropdown-dot {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: $color-secondary;
  flex-shrink: 0;
  opacity: 0;
  transform: scale(0);
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);

  .dropdown-link:hover &,
  li.active & {
    opacity: 1;
    transform: scale(1);
  }
}

// ========== Hamburger ==========
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  gap: 5px;
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  z-index: $z-index-header + 3;

  @include tablet-only { display: flex; }
  @include mobile-only { display: flex; }

  span {
    display: block;
    width: 22px;
    height: 2px;
    background-color: $color-text;
    border-radius: 2px;
    transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: center;
    pointer-events: none;
  }

  &.open {
    span:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
      transform: scaleX(0);
    }
    span:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

// ========== Overlay ==========
.menu-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: $z-index-header + 1;
  animation: overlay-in 0.35s ease both;
}

@keyframes overlay-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

// ========== Mobile Drawer ==========
.mobile-nav {
  position: fixed;
  top: 0;
  right: 0;
  width: 320px;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.98);
  backdrop-filter: saturate(180%) blur(30px);
  -webkit-backdrop-filter: saturate(180%) blur(30px);
  z-index: $z-index-header + 2;
  overflow-y: auto;
  border-left: 1px solid rgba(139, 115, 85, 0.06);
  animation: drawer-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) both;

  @include mobile-only {
    width: 100%;
    border-left: none;
  }
}

@keyframes drawer-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.mobile-nav-inner {
  padding: calc(#{$header-height} + 32px) 36px 48px;

  @include mobile-only {
    padding: calc(#{$header-height-mobile} + 28px) 28px 48px;
  }
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;

  > li:not(.mobile-section-label):not(.sub-item) {
    border-bottom: 1px solid rgba(139, 115, 85, 0.06);

    > a {
      display: block;
      padding: 18px 0;
      font-size: 18px;
      font-weight: $font-weight-semibold;
      color: $color-text;
      text-decoration: none;
      transition: color 0.2s ease, padding-left 0.3s ease;
      letter-spacing: 0.3px;

      &:hover,
      &:active {
        color: $color-primary;
        padding-left: 4px;
      }
    }

    &.active > a {
      color: $color-primary;
    }
  }

  .mobile-section-label {
    border-bottom: none;
    padding-top: 8px;

    &:first-child {
      padding-top: 0;
    }
  }

  .mobile-sub-title {
    display: block;
    padding: 20px 0 8px;
    font-size: 12px;
    font-weight: $font-weight-semibold;
    color: $color-text-light;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    border-bottom: 1px solid rgba(139, 115, 85, 0.08);
  }

  .sub-item {
    border-bottom: none;

    a {
      display: block;
      padding: 12px 0 12px 16px;
      font-size: 16px;
      font-weight: $font-weight-medium;
      color: $color-text-secondary;
      text-decoration: none;
      transition: color 0.2s ease, padding-left 0.3s ease;
      border-left: 2px solid transparent;

      &:hover,
      &:active {
        color: $color-primary;
        padding-left: 20px;
        border-left-color: rgba($color-primary, 0.2);
      }
    }

    &.active a {
      color: $color-primary;
      border-left-color: $color-primary;
    }
  }
}
</style>
